/**
 * @generated SignedSource<<154846736bc063189a3df0e726575610>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteHeader_viewer$data = {
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"JoinConferenceButton_viewer" | "MoreActionsMenuNote_viewer" | "RecordingControls_viewer">;
  readonly " $fragmentType": "NoteHeader_viewer";
};
export type NoteHeader_viewer$key = {
  readonly " $data"?: NoteHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordingControls_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinConferenceButton_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoreActionsMenuNote_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a552307801f1e35a85ed26e1c1507251";

export default node;
